import { ja } from './ja'
import { en } from './en'
import { ko } from './ko'
import { zhHans } from './zh-Hans'
import { zhHant } from './zh-Hant'
import { es } from './es'
import { fr } from './fr'
import { de } from './de'
import { it } from './it'
import { ptBR } from './pt-BR'
import { id } from './id'
import { th } from './th'
import { vi } from './vi'
import { hi } from './hi'
import { ar } from './ar'
import { ru } from './ru'
import { tr } from './tr'
import { nl } from './nl'
import type { SupportedLocale } from '../locales'
import type { TranslationDict } from './ja'

export const dictionaries: Record<SupportedLocale, TranslationDict> = {
  ja,
  en,
  ko,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  es,
  fr,
  de,
  it,
  'pt-BR': ptBR,
  id,
  th,
  vi,
  hi,
  ar,
  ru,
  tr,
  nl,
}

export { ja, en }
